<template>
  <div class="Genitores mb-2">
    <div class="Genitores_header mb-3"
         :class="{'Genitores_header_error': error_general}">
      <div class="row no-gutters align-items-center justify-content-between">
        <div class="col">
          <h2 class="Genitores_header_title">
            Genitores
            <span v-if="error_general">
              <IconSvg class="icon-error-campo"
                       icon="alert" />
              Há campos incorretos {{ verifyErrosGenitores() }}
            </span>
          </h2>
        </div>
      </div>
    </div>
    <div class="Genitores_body">
      <BoxGenitor v-for="(pessoa, index) in genitores"
                  :key="index"
                  :prop-verify-sexo-genitores="verifySexoGenitor(pessoa.pessoa.sexo)"
                  :prop-correcoes="propCorrecoes"
                  :prop-nascimento="propNascimento"
                  :pessoa="pessoa"
                  :prop-ordem="propOrdem">
        <slot>
          <button type="button"
                  class="btn btn-sm btn-danger mr-2"
                  @click="remove(pessoa, index)">
            Remover
          </button>

          <button class="btn btn-sm btn-primary"
                  type="button"
                  @click="edit(pessoa, index)">
            Editar
          </button>
        </slot>
      </BoxGenitor>
    </div>

    <button v-b-modal="`addGenitor_${_uid}`"
            :class="`btn btn-sm btn-outline-primary btn-add-genitor btn-block my-3 addGenitor_${propOrdem}`"
            type="button"
            @click="modalAdd = true">
      <IconSvg class="icon-add icon--sm mr-1"
               icon="add" />
      Adicionar genitor
    </button>
    <b-modal v-if="modalEdit"
             :id="`editGenitor_${_uid}`"
             :ref="`editGenitor_${_uid}`"
             modal-class="modalAddGenitor"
             body-class="modalAddGenitor_body"
             header-class="modalAddGenitor_header"
             :visible="true"
             centered
             size="xl"
             no-close-on-backdrop
             no-close-on-esc
             @ok="modalChanged"
             @hide="modalChanged">
      <div slot="modal-header"
           class="modalGenitor_title w-100">
        Cadastro de Genitor
      </div>
      <div class="mt-3">
        <FormGenitor :genitor="localData"
                     :prop-validate="propValidate"
                     :prop-nascimento="propNascimento"
                     :campo-declarante="campoDeclarante"
                     :prop-cartorio="propCartorio"
                     :to-edit="true"
                     :prop-tipo-registro="propTipoRegistro"
                     @changed="updateDadosGenitor"
                     @removeDocumento="removeDocumento"
                     @deleteAvo="deleteAvo" />
      </div>

      <div slot="modal-footer"
           slot-scope="{ ok, cancel }"
           class="modalEditGenitor_footer">
        <button id="btn-cancel-genitor"
                class="btn btn-sm btn-dark mr-2"
                @click="cancel()">
          Voltar
        </button>
        <button id="btn-submit-genitor"
                class="btn btn-sm btn-primary"
                type="submit"
                @click="updateGenitor">
          Atualizar
        </button>
      </div>
    </b-modal>

    <b-modal v-if="modalAdd"
             :id="`addGenitor_${_uid}`"
             :ref="`addGenitor_${_uid}`"
             modal-class="modalAddGenitor"
             body-class="modalAddGenitor_body"
             header-class="modalAddGenitor_header"
             :visible="true"
             centered
             size="xl"
             no-close-on-backdrop
             no-close-on-esc
             @ok="modalChanged"
             @hide="modalChanged">
      <div slot="modal-header"
           class="modalGenitor_title w-100">
        Cadastro de Genitor
      </div>
      <div class="mt-3">
        <FormGenitor :genitor="localData"
                     :genitores="genitores"
                     :prop-cartorio="propCartorio"
                     :prop-validate="propValidate"
                     :prop-nascimento="propNascimento"
                     :campo-declarante="campoDeclarante"
                     :endereco-registrado="enderecoRegistrado"
                     :prop-predefine-address="predefineAddress"
                     :prop-tipo-registro="propTipoRegistro"
                     :prop-data="propData"
                     @changed="getDadosGenitor" />
      </div>

      <div slot="modal-footer"
           slot-scope="{ ok, cancel }"
           class="modalAddGenitor_footer">
        <button id="btn-cancel-genitor"
                class="btn btn-sm btn-dark mr-2"
                @click="cancel()">
          Voltar
        </button>
        <button id="btn-submit-genitor"
                class="btn btn-sm btn-primary"
                type="submit"
                :disabled="disabled()"
                @click="submitGenitor">
          Continuar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import BoxGenitor from '../../BoxGenitores.vue'
  import FormGenitor from '@/components/SofiaRei/Obito/Forms/FormGenitor'

  /* filters */
  import { filterMaskedNumber } from '@/filters/filters'

  export default {
    name: 'Genitores',
    components: { BoxGenitor, FormGenitor },
    props: {
      noAddButton: Boolean,
      genitores: Array,
      enderecoRegistrado: Object,
      pessoaId: Number,
      readOnly: { type: Boolean, default: () => false },
      campoDeclarante: { type: Boolean, default: false },
      registroParte: { type: [Number, null], default: null },
      propCartorio: { type: Object, default: () => { return {} }},
      propValidate: { type: Boolean, default: false },
      propNascimento: { type: Boolean, default: false },
      propTipoRegistro: {type: String, default: () => ('')},
      propCorrecoes: {type: Object, default: () => ({})},
      partes: { type: Array, default: () => ([])},
      propOrdem: { type: Number, default: 0},
      propData: { type: Object, default: () => ({}) }
    },
    provide () {
      return {
        $validator: this.$validator,
      }
    },
    data () {
      return {
        localData: {
          filiacao: [
            {nome: ''},
            {nome: ''}
          ],
          pessoa: {
            cpf: null,
            sexo: '',
            endereco: {},
            documentos: [],
            idade: 0,
            nacionalidade_codigo: 76,
            nacionalidade: {
              nacionalidade_codigo: 76,
              nome: 'Brasil',
              nome_masculino: 'brasileiro',
              nome_feminino: 'brasileira'
            },
            falecido: false
          },
          declarante: false
        },
        dadosCartorio: {},
        predefineAddress: {},
        modalAdd: false,
        modalEdit: false,
        error_general: false
      }
    },
    watch: {
      propCartorio () {
        if (this.propCartorio && this.propCartorio.endereco) {
          // this.localData.pessoa.uf = this.propCartorio.endereco.uf
          // this.localData.pessoa.naturalidade = this.propCartorio.endereco.cidade
        }
      },
      propCorrecoes () {
        this.verifyErrorsCarga()
      }
    },
    mounted () {
      this.verifyErrorsCarga()
      this.localData = {
        filiacao: [
          {nome: ''},
          {nome: ''}
        ],
        pessoa: {
          cpf: null,
          sexo: '',
          endereco: {
            uf: null,
            cidade: null,
            ibge: null,
            atual: true
          },
          // uf: this.propCartorio.endereco ? this.propCartorio.endereco.uf : '',
          // naturalidade: this.propCartorio.endereco ? this.propCartorio.endereco.cidade : '',
          uf: null,
          naturalidade: null,
          documentos: [],
          idade: 0,
          nacionalidade_codigo: 76,
          nacionalidade: {
            nacionalidade_codigo: 76,
            nome: 'Brasil',
            nome_masculino: 'brasileiro',
            nome_feminino: 'brasileira'
          },
          falecido: false
        },
        declarante: false
      }
    },
    methods: {
      modalChanged () {
        this.localData = {
          filiacao: [
            {nome: ''},
            {nome: ''}
          ],
          pessoa: {
            cpf: null,
            sexo: '',
            endereco: {
              uf: null,
              cidade: null,
              ibge: this.propCartorio.endereco ? this.propCartorio.endereco.ibge : null,
              atual: true
            },
            // uf: this.propCartorio.endereco ? this.propCartorio.endereco.uf : '',
            // naturalidade: this.propCartorio.endereco ? this.propCartorio.endereco.cidade : '',
            uf: null,
            naturalidade: null,
            documentos: [],
            idade: 0,
            nacionalidade_codigo: 76,
            nacionalidade: {
              nacionalidade_codigo: 76,
              nome: 'Brasil',
              nome_masculino: 'brasileiro',
              nome_feminino: 'brasileira'
            },
            falecido: false
          },
          declarante: false
        },
        this.predefineAddress = {}
        this.modalAdd = false
        this.modalEdit = false
      },
      setNull () {
        this.localData.pessoa.cpf = this.localData.pessoa.cpf || null
      },
      async submitGenitor () {
        this.$validator.validate().then(resp => {
          let invalids = document.querySelectorAll('.Genitores .is-invalid')

          if (resp && invalids.length === 0) {
            if (!this.genitores.length) {
              this.deleteError([
                'PAI',
                'MÃE',
                'GENITOR',
                `PAI DO CÔNJUGE ${this.propOrdem}`,
                `MÃE DO CÔNJUGE ${this.propOrdem}`
              ])
            }

            this.setNull()

            const genitor = this.localData

            genitor.filiacao = genitor.filiacao.filter(avo => avo.nome)

            if (this.localData.pessoa.nome) {
              this.localData.pessoa.nome = this.localData.pessoa.nome.toUpperCase()
            }

            this.$emit('genitorAdded', genitor)

            this.modalChanged()
          }
        })
      },
      async updateGenitor () {
        this.$validator.validate().then(resp => {
          let invalids = document.querySelectorAll('.Genitores .is-invalid')

          if (resp && invalids.length === 0) {
            try {
              this.setNull()
              const genitor = this.localData

              genitor.genitorParte = null
              genitor.filiacao = genitor.filiacao.filter(avo => avo.nome)

              // Valida se os campos obrigatórios foram preenchidos (Nome e Sexo)
              if (!genitor.pessoa.nome || (genitor.pessoa.nome === '')) return
              if (!genitor.pessoa.sexo || (genitor.pessoa.sexo === '')) return

              if (this.localData.pessoa.nome) {
                this.localData.pessoa.nome = this.localData.pessoa.nome.toUpperCase()
              }

              if (genitor.pessoa.sexo == 'M')  this.deleteError(['PAI',  `PAI DO CÔNJUGE ${this.propOrdem}`])
              else this.deleteError(['MÃE',  `MÃE DO CÔNJUGE ${this.propOrdem}`])

              // Caso falecido esteje false temos que tirar o local da ocorrencia dele
              if (!genitor.pessoa.falecido) {
                genitor.local_ocorrencia_falecimento_id = null
              }

              this.$emit('genitorUpdated', genitor, genitor.localId)
              //this.$refs[`editGenitor_${ this._uid }`].hide()

              this.modalChanged()
            } catch (err) {
              objSwal.error.title = 'Erro ao atualizar Genitor'
              objSwal.error.text = err.message
              Swal.fire(objSwal.error)

              const btnConfirm = document.querySelector('.swal2-confirm')

              if (btnConfirm) btnConfirm.focus()

              this.modalChanged()
            }
          }
        })
      },
      edit (genitor, localId) {
        this.modalEdit = true

        const declarante = !!genitor.genitorParte || genitor.declarante

        this.localData = { ...genitor, localId, declarante }

        //this.$refs[`editGenitor_${ this._uid }`].show()
      },
      async remove (genitor, index) {
        if (genitor.genitorParte ) {

          objSwal.question.title = ''
          objSwal.question.text = 'Esta pessoa também é o declarante. Deseja excluir o cadastro de declarante dela?'
          objSwal.question.cancelButtonText = 'Não'
          objSwal.question.confirmButtonText = 'Sim'

          const res = await Swal.fire(objSwal.question)

          objSwal.question.title = ''
          objSwal.question.text = ''
          objSwal.question.html = ''

          if (res.value) {
            this.$emit('removeGenitorDeclarante', genitor.genitorParte.parte_id)
          }
        }
        if (genitor.pessoa.sexo == 'M')  this.deleteError(['PAI',  `PAI DO CÔNJUGE ${this.propOrdem}`])
        else this.deleteError(['MÃE',  `MÃE DO CÔNJUGE ${this.propOrdem}`])

        this.$emit('genitorRemoved', index)
        objSwal.success.title = "Removido com Sucesso"
        objSwal.success.text = ''

        Swal.fire(objSwal.success).then(() => {
          setTimeout(() => {
            const btnAdd = window.document.querySelector(`.addGenitor_${this.propOrdem}`)

            if (btnAdd) btnAdd.focus()
          }, 200)
        }, 200)

        const btnConfirm = document.querySelector('.swal2-confirm')

        if (btnConfirm) btnConfirm.focus()
      },
      disabled () {
        if (!this.localData || (this.localData && !this.localData.pessoa)) return

        let disabled = true

        const { pessoa: { nome, sexo, cpf } } = this.localData

        if (nome && sexo && !cpf) {
          disabled = false
        } else if (nome && sexo && cpf) {
          // Tiramos a pontuação
          let cpfSemMascara = filterMaskedNumber(cpf)
          // Tiramos o underline que o v-mask coloca em espaços vazios
          cpfSemMascara = cpfSemMascara.replace(/_/g, "")

          // Se o cpf estiver completo, habilitamos o botão
          if (cpfSemMascara.length === 11) {
            disabled = false
          }
        }

        return disabled
      },
      getDadosGenitor (genitor) {
        this.localData = genitor
      },
      updateDadosGenitor (genitor) {
        this.localData = genitor
      },

      removeDocumento (documento) {
        this.$emit('removeDocumento', documento)
      },
      deleteAvo (avo_id) {
        this.$emit('deleteAvo', avo_id)
      },
      verifyErrosGenitores () {
        const errosMae = this.propCorrecoes['MÃE'] || this.propCorrecoes[`MÃE DO CÔNJUGE ${this.propOrdem}`]
        const errosPai = this.propCorrecoes['PAI'] || this.propCorrecoes[`PAI DO CÔNJUGE ${this.propOrdem}`]

        const pai = this.genitores.filter(genitor => genitor.pessoa.sexo == 'M')
        const mae = this.genitores.filter(genitor => genitor.pessoa.sexo == 'F')


        if (mae.length == 1 && pai.length == 1 && errosPai && errosMae) {
          return 'em genitor 1 e genitor 2'
        } else if (pai.length == 1 && errosPai) {
          return `em genitor ${this.genitores.findIndex(genitor => genitor == pai[0]) + 1}`
        } else if (mae.length == 1 != 1 && errosMae) {
          return `em genitor ${this.genitores.findIndex(genitor => genitor == mae[0]) + 1}`
        }

      },
      verifySexoGenitor (sexo) {
        const genitor = this.genitores.filter(genitor => genitor.pessoa.sexo == sexo)

        if (genitor.length == 1) return true
      },
      deleteError (error) {
        this.$emit('deleteError', error)
      },
      verifyErrorsCarga () {
        this.error_general = false

        Object.keys(this.propCorrecoes).forEach(key => {
          if (['PAI', 'MÃE', 'GENITOR', `MÃE DO CÔNJUGE ${this.propOrdem}`, `PAI DO CÔNJUGE ${this.propOrdem}`].indexOf(key) != -1) this.error_general = true
        })
      }
    },
  }
</script>

<style lang="scss">
  @import '../../../../../scss/_utilities/_exports';

  .Genitores {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;

      &_error {
        color: #8B0000
      }

      &_title {
        @extend %titleBox_title;
      }
    }
  }

  .modalAddGenitor {
    &_body {
      border-bottom: pxToRem(1) solid $sinoreg-blue;
      margin: 0 pxToRem(20);
      padding: 0;
    }

    &_footer {
      border: none;
    }

    &_header{
      padding: 0 0;
    }

    .modal-footer {
      border: none;
    }
  }

  .btn-add-genitor:hover > [class*=icon-add] {
    fill: #fff !important;
  }
  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }
  .modalGenitor{
    &_title{
    background-color: #074f7f;
    color: #fff;
    font-size: 1.5rem;
    font-weight: 500;
    padding: 0.625rem 1.25rem;
    }
  }
</style>
